import Dashboard from './Dashboard';
import Copyright from '@/components/Copyright';
import PageToolbar from '@/components/PageToolbar';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tabs, Tab, Panel, Grid, Row, Col, Breadcrumb, SelectPicker } from 'rsuite';
import { Table, Pagination, Loader } from 'rsuite';
import { TiHome } from 'react-icons/ti';
import { BiExport } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import { FaBuilding } from 'react-icons/fa6';
import { RiCalendarCloseFill, RiUserLocationFill } from 'react-icons/ri';
import { BsSuitcaseFill } from 'react-icons/bs';
import { FaRegQuestionCircle } from 'react-icons/fa'; // Icône par défaut
import { PiOfficeChairFill } from 'react-icons/pi';
import { FaHouseCircleExclamation, FaMapLocationDot } from 'react-icons/fa6';
import { MdGroup } from 'react-icons/md';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {
  Drawer,
  Form,
  Button,
  Message,
  toaster,
  Input,
  TagPicker,
  List,
  HStack,
  VStack,
  InputGroup,
  Text,
  Stack
} from 'rsuite';
import { CSVLink } from 'react-csv'; // Pour l'export CSV

import Chart from 'react-apexcharts';
import moment from 'moment';
import './styles.less';

import { fetchWorkModsByUser, ReservationCheckin } from '@/services/dashboard.service';
import { ReservationWeek } from '@/services/dashboard.service';
import { OperationToday } from '@/services/dashboard.service';
import { OperationPeriod } from '@/services/dashboard.service';

import { OperationDepartement } from '@/services/dashboard.service';
import { getReservationCountPerDay } from '@/services/dashboard.service';
import { getALLOperations } from '@/services/dashboard.service';
import { useAppSelector } from '@/config/hooks';

import { CombinedStatus } from '@/services/dashboard.service';
import { spacesStatus } from '@/services/dashboard.service';
import { WorkModesDistribution } from '@/services/dashboard.service';
import { zoneByFloor } from '@/services/dashboard.service';
import { teamWorkspaces } from '@/services/dashboard.service';

const ReportingDashboard = () => {
  const { Column, HeaderCell, Cell } = Table;
  const [modes, setModes] = useState([]);
  const features = useAppSelector(state => state.feature.data);

  const [globalStats, setGlobalStats] = useState({ globalBookingRate: 0, occupationRate: 0 });
  const [operationsData, setOperationsData] = useState([]);
  const [departmentChartData, setDepartmentChartData] = useState({ series: [], options: {} });
  const [reservationStats, setReservationStats] = useState({
    reservationCount: 0,
    checkinCount: 0
  });
  const [combinedStatusData, setCombinedStatusData] = useState({ series: [], options: {} });
  const [pieChartData, setPieChartData] = useState({ series: [], labels: [] });
  const [deskStats, setDeskStats] = useState({ series: [], options: {} });

  const [radialData, setRadialData] = useState({ series: [], options: {} });
  const [chartData, setChartData] = useState({ desks: [], meetingRooms: [] });
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const [weeklyWorkModes, setWeeklyWorkModes] = useState({ series: [], options: {} });
  const [selectedUserId, setSelectedUserId] = useState('65646565cbaea51bf163d4ea');
  const [selectedPeriod, setSelectedPeriod] = useState(7);
  const [workModeData, setWorkModeData] = useState([]);
  const [reservationData, setReservationData] = useState({ categories: [], series: [] });
  const [operations, setOperations] = useState([]);
  const [page, setPage] = useState(1);

  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [autoHeight, setAutoHeight] = useState(true);
  const [height, setHeight] = useState(400);
  const [minHeight, setMinHeight] = useState(200);
  const [maxHeight, setMaxHeight] = useState(600);
  const Label = ({ children }) => <div style={{ width: 76 }}>{children}</div>;
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      operations.map(row => ({
        LastName: row.user?.lastname || 'N/A',
        FirstName: row.user?.firstname || 'N/A',
        ServiceLine: row.user?.serviceLine?.serviceLine || 'N/A',
        OperationType: row.OperationType || 'N/A',
        ReservationDate: normalizeDateField(row)
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Operations');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    saveAs(data, 'operations.xlsx');
  };
  const operationConfig = {
    RESERVATION: {
      label: t('Flex office'),
      color: '#0d47a1'
    },
    Leave: {
      label: t('Leave'),
      color: '#ab9a00'
    },
    TRAVEL: {
      label: t('Business Travel'),
      color: '#6c396b'
    },
    WFH: {
      label: t('Home office'),
      color: '#2ec7ff'
    },
    'Client site': {
      label: t('Third party site'),
      color: '#e91e63'
    },
    REMOTE_WORKING: {
      label: t('Exceptional home office'),
      color: '#ff9800'
    }
  };
  const operationOrder = ['Leave', 'Client site', 'RESERVATION', 'WFH', 'TRAVEL'];
  const operationColors = ['#ab9a00', '#e91e63', '#ff9800', '#2ec7ff', '#6c396b'];
  // const normalizeDateField = (row) => {
  //   return row.reservationdate ?? row.date ?? row.date_debut ?? row.date_fin ?? "N/A";
  // };

  const normalizeDateField = row => {
    const dateValue = row.reservationdate ?? row.date ?? row.date_debut ?? row.date_fin;
    if (!dateValue) return 'N/A';

    try {
      const date = new Date(dateValue);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
        date.getDate()
      ).padStart(2, '0')}`;
    } catch (e) {
      return 'N/A';
    }
  };

  const formatOperationLabel = label => {
    if ([t('RESERVATION'), t('WFH'), t('TRAVEL')].includes(label)) {
      return label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
    }
    return label;
  };

  useEffect(() => {
    // Fonction pour récupérer la liste des utilisateurs

    // Fonction de récupération des stats globales
    const fetchGlobalStats = async () => {
      try {
        const response = await spacesStatus();
        setGlobalStats({
          globalBookingRate: Math.round(response.data.globalBookingRate),
          occupationRate: Math.round(response.data.occupationRate)
        });
      } catch (error) {
        console.error('Error fetching global stats', error);
      }
    };

    const fetchOperationsData = async () => {
      try {
        const response = await OperationToday();
        if (response) {
          const operationsMap = response.reduce((acc, op) => {
            acc[op._id] = op.count;
            return acc;
          }, {});
          const orderedData = operationOrder.map(type => ({
            _id: type,
            count: operationsMap[type] || 0
          }));
          setOperationsData(orderedData);
        }
      } catch (error) {
        console.error('Error fetching operations data', error);
      }
    };

    const fetchDepartmentOperations = async () => {
      const endDate = new Date().toISOString().split('T')[0];
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - selectedPeriod);
      const formattedStartDate = startDate.toISOString().split('T')[0];

      // Palette de couleurs distinctes pour chaque mode
      const workModeColors = {
        'Flex Office': '#0146Ed', // Bleu vif
        'Home Office': '#00E396', // Vert
        'Third Party Site': '#FEB019', // Orange
        'Business Travel': '#FF4560', // Rouge
        Leave: '#775DD0' // Violet
      };

      try {
        const response = await OperationDepartement(formattedStartDate, endDate);
        if (response) {
          const formattedSeries = [];
          const formattedCategories = Object.keys(response);
          const allWorkModes = Object.keys(workModeColors);

          allWorkModes.forEach(workMode => {
            const operationData = formattedCategories.map(
              department => response[department]?.[workMode] || 0
            );

            formattedSeries.push({
              name: workMode,
              data: operationData
            });
          });

          setDepartmentChartData({
            series: formattedSeries,
            options: {
              chart: { type: 'bar', height: 350, stacked: true },
              plotOptions: { bar: { columnWidth: '30%' } },
              xaxis: { categories: formattedCategories },
              yaxis: { title: { text: t('Number of Operations') } },
              legend: { position: 'bottom' }
            }
          });
        }
      } catch (error) {
        console.error('Error fetching department operations', error);
      }
    };
    const fetchReservationCheckinData = async () => {
      const endDate = new Date().toISOString().split('T')[0];
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - selectedPeriod);
      const formattedStartDate = startDate.toISOString().split('T')[0];
      try {
        const response = await ReservationCheckin(formattedStartDate, endDate);
        if (response) {
          console.log('Données reçues :', response);
          setReservationStats({
            reservationCount: response.reservationCount || 0,
            checkinCount: response.checkinCount || 0
          });
        }
      } catch (error) {
        console.error('Error fetching reservation and check-in data', error);
      }
    };

    const fetchCombinedStatusData = async () => {
      try {
        const todayDate = new Date().toISOString().split('T')[0]; // Date du jour
        const response = await CombinedStatus(todayDate);
        //const response = await axios.get(`http://localhost:5001/api/Operation/users-with-untraced/2025-03-17`);

        if (response.data && response.data.data) {
          console.log('Données reçues Combined Status :', response.data);
          const departments = Object.keys(response.data.data);

          // Séparer Traced et Untraced pour AM & PM
          const amTraced = {
            name: t('AM Traced'),
            data: departments.map(dept => response.data.data[dept]?.AM?.tracedUsers || 0)
          };

          const amUntraced = {
            name: t('AM Untraced'),
            data: departments.map(dept => response.data.data[dept]?.AM?.untracedUsers || 0)
          };

          const pmTraced = {
            name: t('PM Traced'),
            data: departments.map(dept => response.data.data[dept]?.PM?.tracedUsers || 0)
          };

          const pmUntraced = {
            name: t('PM Untraced'),
            data: departments.map(dept => response.data.data[dept]?.PM?.untracedUsers || 0)
          };

          setCombinedStatusData({
            series: [amTraced, amUntraced, pmTraced, pmUntraced],
            options: {
              chart: { type: 'bar', height: 350, stacked: false },
              plotOptions: {
                bar: { columnWidth: '50%', grouped: true }
              },
              xaxis: {
                categories: departments,
                title: { text: t('Departments') }
              },
              yaxis: {
                title: { text: t('Number of Users') }
              },
              legend: { position: 'top' },
              colors: ['#4c8dff', '#ff861c', '#2ec7ff', '#fe3993'] // Bleu AM Traced, Orange AM Untraced, Cyan PM Traced, Rose PM Untraced
            }
          });
        }
      } catch (error) {
        console.error('Error fetching combined status data', error);
      }
    };

    const fetchPieChartData = async () => {
      try {
        const todayDate = new Date().toISOString().split('T')[0]; // Date du jour
        const response = await WorkModesDistribution(todayDate);

        console.log('Réponse complète :', response.data);

        if (response.data && response.data.data) {
          console.log('Données Pie Chart :', response.data);

          const globalAverages = response.data.data.globalAverages; // Récupération des moyennes globales

          if (globalAverages && globalAverages.length > 0) {
            const series = globalAverages.map(item => Number(item.avgRate.toFixed(2))); // Arrondi à 2 décimales
            const labels = globalAverages.map(item => item.workMode.trim()); // Suppression des espaces inutiles

            setPieChartData({ series, labels });
          } else {
            console.warn('Aucune donnée globale trouvée pour le Pie Chart.');
            setPieChartData({ series: [], labels: [] });
          }
        }
      } catch (error) {
        console.error('Error fetching pie chart data', error);
      }
    };

    const fetchDeskStats = async () => {
      try {
        const response = await zoneByFloor();
        if (response.data && response.data.status === 200) {
          const data = response.data.data;
          const floors = Object.keys(data);
          const bookingRates = floors.map(floor => parseFloat(data[floor].globalBookingRate));
          const occupationRates = floors.map(floor => parseFloat(data[floor].occupationRate));
          setDeskStats({
            series: [
              { name: t('Global Booking Rate'), data: bookingRates },
              { name: t('Occupation Rate'), data: occupationRates }
            ],
            options: {
              chart: { type: 'bar', height: 350, stacked: false },
              xaxis: { categories: floors },
              yaxis: { title: { text: t('Rates') } },
              legend: { position: 'top' },
              colors: ['#4c8dff', '#ff861c'],
              plotOptions: { bar: { columnWidth: '50%' } },
              dataLabels: { enabled: true }
            }
          });
        }
      } catch (error) {
        console.error('Error fetching desk stats', error);
      }
    };

    // Nouveau fetch pour les données Treemap (Heatmap alternative)

    const fetchRadialData = async () => {
      try {
        const startDate = moment().subtract(8, 'days').format('YYYY-MM-DD');
        const endDate = moment().format('YYYY-MM-DD');
        const response = await ReservationWeek(startDate, endDate);

        // Période de la semaine dernière (7 derniers jours)

        if (response) {
          // Ordre souhaité des jours : Lundi à Dimanche
          const order = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

          const sortedData = order.map(day => {
            const found = response.find(item => item.day === day);
            return found ? found : { day, count: 0 };
          });
          const series = sortedData.map(item => item.count);
          const labels = sortedData.map(item => item.day);

          setRadialData({
            series,
            options: {
              chart: { type: 'radialBar', height: 500 },
              plotOptions: {
                radialBar: {
                  offsetY: 0,
                  startAngle: 0,
                  endAngle: 270,
                  hollow: {
                    margin: 5,
                    size: '30%',
                    background: 'transparent',
                    image: undefined
                  },

                  // Masquer les dataLabels par défaut
                  dataLabels: {
                    name: {
                      show: true,
                      fontSize: '16px',
                      offsetY: -10
                    },
                    value: {
                      show: true,
                      fontSize: '14px',
                      offsetY: 10,
                      formatter: function (seriesName, opts) {
                        return seriesName + ' Bookings';
                      }
                    }
                  },
                  // Afficher les barLabels personnalisés
                  barLabels: {
                    enabled: true,

                    useSeriesColors: true,
                    offsetX: -10,
                    fontSize: '16px',
                    formatter: function (seriesName, opts) {
                      // Concatène le nom du jour (défini dans labels) et la valeur (nombre de réservations)
                      return seriesName;
                    }
                  }
                }
              },
              colors: ['#1ab7ea', '#0084ff', '#39539E', '#0077B5', '#0088B5', '#02589E'],
              labels
            }
          });
        }
      } catch (error) {
        console.error('Error fetching radial chart data', error);
      }
    };

    // const fetchUserWeeklyWorkModes = async () => {
    //   try {
    //     const response = await fetchWorkModsByUser(selectedUserId);
    //     if (response) {
    //       const weekData = response;

    //       // Traduction des jours
    //       const dayTranslations = {
    //         Monday: "Lundi",
    //         Tuesday: "Mardi",
    //         Wednesday: "Mercredi",
    //         Thursday: "Jeudi",
    //         Friday: "Vendredi"
    //       };

    //       // Définition des couleurs par mode de travail
    //       const modeColors = {
    //         "On site": "#0d47a1",
    //         "Meeting": "#4c8dff",
    //         "Leave": "#ab9a00",
    //         "Travel": "#6c396b",
    //         "Wfh": "#2ec7ff",
    //         "Client Site": "#e91e63",
    //         "Untraced": "#ff0000"
    //       };

    //       // Détection du jour actuel
    //       const today = new Date().toLocaleDateString("fr-FR", { weekday: "long" });

    //       // Création des données pour le heatmap
    //       const amData = Object.keys(dayTranslations).map((day) => {
    //         const translatedDay = dayTranslations[day];
    //         const mode = weekData[day]?.AM || "non tracé";

    //         return {
    //           x: translatedDay,
    //           y: 1, // Valeur arbitraire pour heatmap
    //           name: mode,
    //           fillColor: translatedDay.toLowerCase() === today.toLowerCase() ? "#ff9800" : modeColors[mode] || "#cccccc"
    //         };
    //       });

    //       const pmData = Object.keys(dayTranslations).map((day) => {
    //         const translatedDay = dayTranslations[day];
    //         const mode = weekData[day]?.PM || "non tracé";

    //         return {
    //           x: translatedDay,
    //           y: 1, // Valeur arbitraire pour heatmap
    //           name: mode,
    //           fillColor: translatedDay.toLowerCase() === today.toLowerCase() ? "#008ffb" : modeColors[mode] || "#cccccc"
    //         };
    //       });

    //       // Mise à jour du state
    //       setWeeklyWorkModes({
    //         series: [
    //           { name: "AM", data: amData },
    //           { name: "PM", data: pmData }
    //         ],
    //         options: {
    //           chart: { type: "heatmap", height: 250 },
    //           dataLabels: {
    //             enabled: true,
    //             formatter: function (_, opts) {
    //               return opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].name;
    //             },
    //             style: { colors: ["#fff"] }
    //           },

    //           tooltip: {
    //             custom: function ({ seriesIndex, dataPointIndex, w }) {
    //               const period = seriesIndex === 0 ? "AM" : "PM";
    //               const day = w.config.series[seriesIndex].data[dataPointIndex].x;
    //               const mode = w.config.series[seriesIndex].data[dataPointIndex].name;
    //               return `<div class="custom-tooltip"><b>${day} ${period}</b>: ${mode}</div>`;
    //             }
    //           },
    //           xaxis: { categories: Object.values(dayTranslations) },
    //           plotOptions: { heatmap: { enableShades: false } }
    //         }
    //       });
    //     }
    //   } catch (error) {
    //     console.error("Erreur lors de la récupération des modes de travail", error);
    //   }
    // };
    ///////////////////////////////
    const fetchWorkModes = async () => {
      const endDate = new Date().toISOString().split('T')[0];
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - selectedPeriod);
      const formattedStartDate = startDate.toISOString().split('T')[0];
      console.log('Fetching data for: ', formattedStartDate, 'to', endDate);
      try {
        const response = await OperationPeriod(formattedStartDate, endDate);
        if (response) {
          setWorkModeData(response);
        } else {
          setWorkModeData([]);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des modes de travail', error);
      }
    };
    const fetchReservationData = async () => {
      let startDate,
        endDate = new Date(); // Par défaut, endDate = aujourd'hui

      const today = new Date();

      if (selectedPeriod === 7) {
        // 7 derniers jours (au lieu de Lundi-Vendredi)
        startDate = new Date();
        startDate.setDate(today.getDate() - (((today.getDay() + 6) % 7) + 7)); // Lundi dernier
      } else if (selectedPeriod === 15) {
        // 15 derniers jours
        startDate = new Date();
        startDate.setDate(today.getDate() - (((today.getDay() + 6) % 7) + 14)); // Lundi d'il y a 2 semaines
      } else {
        // 30 derniers jours
        startDate = new Date();
        startDate.setDate(today.getDate() - (((today.getDay() + 6) % 7) + 28)); // Lundi d'il y a 4 semaines
      }

      // Formatage des dates
      startDate = startDate.toISOString().split('T')[0];
      endDate.setDate(today.getDate() - (((today.getDay() + 6) % 7) + 1)); // Vendredi dernier
      //endDate = endDate.toISOString().split('T')[0];

      try {
        const response = await getReservationCountPerDay(startDate, endDate);
        if (response) {
          const categories = response.map(item => item.day || item.week);
          const series = [{ name: t('Bookings'), data: response.map(item => item.count) }];
          setReservationData({ categories, series });
        }
      } catch (error) {
        console.error('Error fetching reservation data: ', error);
      }
    };
    // const fetchReservationData = async () => {
    //   let startDate, endDate;

    //   const today = new Date();

    //   if (selectedPeriod === 7) {
    //     // Lundi-Vendredi de la semaine dernière
    //     startDate = new Date();
    //     startDate.setDate(today.getDate() - (((today.getDay() + 6) % 7) + 7)); // Lundi dernier
    //     // endDate = new Date(startDate);
    //     // endDate.setDate(startDate.getDate() + 5); // Vendredi dernier
    //   } else if (selectedPeriod === 15) {
    //     // 15 derniers jours = 2 semaines (Lundi-Vendredi)
    //     startDate = new Date();
    //     startDate.setDate(today.getDate() - (((today.getDay() + 6) % 7) + 14)); // Lundi d'il y a 2 semaines
    //     // endDate = new Date(today);
    //     // endDate.setDate(today.getDate() - (((today.getDay() + 6) % 7) + 2)); // Vendredi dernier
    //   } else {
    //     // 30 derniers jours = 4 semaines (Lundi-Vendredi)
    //     startDate = new Date();
    //     startDate.setDate(today.getDate() - (((today.getDay() + 6) % 7) + 28)); // Lundi d'il y a 4 semaines
    //     // endDate = new Date(today);
    //     // endDate.setDate(today.getDate() - (((today.getDay() + 6) % 7) + 2)); // Vendredi dernier
    //   }

    //   startDate = startDate.toISOString().split('T')[0];
    //   //endDate = endDate.toISOString().split('T')[0];

    //   try {
    //     const response = await getReservationCountPerDay(startDate, endDate);
    //     if (response) {
    //       const categories = response.map(item => item.day || item.week); // Jour ou Semaine
    //       const series = [{ name: 'Bookings', data: response.map(item => item.count) }];
    //       setReservationData({ categories, series });
    //     }
    //   } catch (error) {
    //     console.error('Error fetching reservation data: ', error);
    //   }
    // };

    const fetchUserWeeklyWorkModes = async () => {
      try {
        const response = await fetchWorkModsByUser(selectedUserId);
        if (response) {
          const weekData = response;

          // Traduction des jours en français
          const dayTranslations = {
            Monday: 'Lundi',
            Tuesday: 'Mardi',
            Wednesday: 'Mercredi',
            Thursday: 'Jeudi',
            Friday: 'Vendredi'
          };

          // Définition des couleurs par mode de travail
          const modeColors = {
            'On site': '#0d47a1', // Bleu foncé
            Meeting: '#4c8dff', // Bleu clair
            Leave: '#ab9a00', // Jaune foncé
            Travel: '#6c396b', // Violet
            Wfh: '#2ec7ff', // Bleu cyan
            'Client Site': '#e91e63', // Rose
            Untraced: '#ff0000' // Rouge
          };

          // Détection du jour actuel en français
          const today = new Date().toLocaleDateString('fr-FR', { weekday: 'long' });

          // Création des données pour le heatmap (AM et PM)
          const amData = Object.keys(dayTranslations).map(day => {
            const translatedDay = dayTranslations[day];
            const mode = weekData[day]?.AM || 'Untraced';
            const isToday = translatedDay.toLowerCase() === today.toLowerCase();

            return {
              x: isToday ? ` ${translatedDay} (Jour actuel)` : translatedDay, // Marque le jour actuel
              y: 1,
              name: ` ${mode}`,
              fillColor: isToday ? '#ff9800' : modeColors[mode] || '#cccccc'
            };
          });

          const pmData = Object.keys(dayTranslations).map(day => {
            const translatedDay = dayTranslations[day];
            const mode = weekData[day]?.PM || 'Untraced';
            const isToday = translatedDay.toLowerCase() === today.toLowerCase();

            return {
              x: isToday ? ` ${translatedDay} (Jour actuel)` : translatedDay,
              y: 1,
              name: ` ${mode}`,
              fillColor: isToday ? '#008ffb' : modeColors[mode] || '#cccccc'
            };
          });

          // Mise à jour du state avec les nouvelles options
          setWeeklyWorkModes({
            series: [
              { name: 'AM', data: amData },
              { name: 'PM', data: pmData }
            ],
            options: {
              chart: { type: 'heatmap', height: 250 },
              dataLabels: {
                enabled: true,
                formatter: function (_, opts) {
                  return opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].name;
                },
                style: { colors: ['#fff'] }
              },

              tooltip: {
                custom: function ({ seriesIndex, dataPointIndex, w }) {
                  const period = seriesIndex === 0 ? 'AM' : 'PM';
                  const day = w.config.series[seriesIndex].data[dataPointIndex].x;
                  const mode = w.config.series[seriesIndex].data[dataPointIndex].name;
                  return `<div class="custom-tooltip"><b>${day} ${period}</b>: ${mode}</div>`;
                }
              },
              xaxis: { categories: Object.values(dayTranslations) },
              plotOptions: { heatmap: { enableShades: false } }
            }
          });
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des modes de travail', error);
      }
    };

    const fetchOperations = async () => {
      setLoading(true);

      const endDate = new Date().toISOString().split('T')[0];
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - selectedPeriod);
      const formattedStartDate = startDate.toISOString().split('T')[0];

      try {
        const response = await getALLOperations(formattedStartDate, endDate);
        if (response) {
          setOperations(response);
        }
        console.log('response des operations (tableau )', response);
      } catch (error) {
        console.error('Error fetching operations:', error);
      } finally {
        setLoading(false);
      }
    };

    // const prepareCSVData = (operations) => {
    //   return operations.map(op => ({
    //     Nom: op.user?.lastname || "N/A",
    //     Prénom: op.user?.firstname || "N/A",
    //     "Service Line": op.user?.serviceLine?.serviceLine || "N/A",
    //     "Type d'Opération": op.OperationType || "N/A",
    //     "Date de Réservation": normalizeDateField(op),
    //   }));
    // };

    // const csvHeaders = [
    //   { label: "last Name", key: "user.lastname" },
    //   { label: "First Name", key: "user.firstname" },
    //   { label: "Service Line", key: "user.serviceLine.serviceLine" },
    //   { label: "Operation Type", key: "OperationType" },
    //   { label: "Reservation Date", key: "reservationdate" },
    // ];
    const fetchWorkspacesBar = async () => {
      try {
        const response = await teamWorkspaces();

        if (response.status === 200) {
          const rawData = response.data.data;
          const categories = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi'];

          const desksData = categories.map(day => {
            const entry = rawData.find(item => item.day === day);
            return entry ? entry.desks : 0;
          });

          const meetingRoomsData = categories.map(day => {
            const entry = rawData.find(item => item.day === day);
            return entry ? entry.meeting_rooms : 0;
          });

          setChartData({ desks: desksData, meetingRooms: meetingRoomsData });
        }
      } catch (error) {
        console.error('Error fetching workspace utilization data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchGlobalStats();
    fetchOperationsData();
    fetchReservationCheckinData();
    fetchDepartmentOperations();
    fetchCombinedStatusData();
    fetchPieChartData();
    fetchDeskStats();
    fetchRadialData();
    fetchUserWeeklyWorkModes();
    fetchWorkModes();
    fetchReservationData();
    fetchOperations();
    fetchWorkspacesBar();
  }, [selectedPeriod, selectedUserId]);
  useEffect(() => {
    const interval = setInterval(() => {
      fetchGlobalStats();
      fetchOperationsData();
      fetchReservationCheckinData();
      fetchDepartmentOperations();
      fetchCombinedStatusData();
      fetchPieChartData();
      fetchDeskStats();

      fetchRadialData();
      fetchUserWeeklyWorkModes();
      fetchWorkModes();
      fetchReservationData();
      fetchOperations();
      fetchWorkspacesBar();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

 useEffect(() => {
  if (!workModeData) return;

  const featuresArray: any = [];
  const addedFeatures = new Set<string>();

  workModeData.forEach((mode) => {
    const modeName = mode.workMode;

    if (addedFeatures.has(modeName)) return;

    switch (modeName) {
      case 'Flex Office':
        featuresArray.push({
          label: t('Flex Office'),
          value: 'Flex Office',
          icon: <PiOfficeChairFill size={50} />,
          color: '#205dbd',
          background: 'linear-gradient(87deg, #205dbd 0, rgb(46, 122, 243) 100%)',
          count: mode.count,
        });
        break;

      case 'Home Office':
        featuresArray.push({
          label: t('Home Office'),
          value: 'Home Office',
          icon: <TiHome size={50} />,
          color: '#205dbd',
          background: 'linear-gradient(87deg, #205dbd 0, rgb(46, 122, 243) 100%)',
          count: mode.count,
        });
        break;

      case 'Exeptional Home office':
        featuresArray.push({
          label: t('Exceptional Home Office'),
          value: 'Exeptional Home office',
          icon: <TiHome size={50} />,
          color: '#205dbd',
          background: 'linear-gradient(87deg, #205dbd 0, rgb(46, 122, 243) 100%)',
          count: mode.count,
        });
        break;

      case 'Third Party Site':
        featuresArray.push({
          label: t('Third Party Site'),
          value: 'Third Party Site',
          icon: <FaBuilding size={50} />,
          color: '#205dbd',
          background: 'linear-gradient(87deg, #205dbd 0, rgb(46, 122, 243) 100%)',
          count: mode.count,
        });
        break;

      case 'Business Travel':
        featuresArray.push({
          label: t('Business Travel'),
          value: 'Business Travel',
          icon: <FaMapLocationDot size={50} />,
          color: '#205dbd',
          background: 'linear-gradient(87deg, #205dbd 0, rgb(46, 122, 243) 100%)',
          count: mode.count,
        });
        break;

      case 'Leave':
        featuresArray.push({
          label: t('Leave'),
          value: 'Leave',
          icon: <RiCalendarCloseFill size={50} />,
          color: '#205dbd',
          background: 'linear-gradient(87deg, #205dbd 0, rgb(46, 122, 243) 100%)',
          count: mode.count,
        });
        break;

      default:
        featuresArray.push({
          label: modeName,
          value: modeName,
          icon: <MdGroup size={50} />,
          color: '#205dbd',
          background: 'linear-gradient(87deg, #205dbd 0, rgb(46, 122, 243) 100%)',
          count: mode.count,
        });
    }

    addedFeatures.add(modeName);
  });

  setModes(featuresArray);
}, [workModeData, t]);

  // const getCountForMode = value => {
  //   const item = workModeData.find(item => item.workMode === value);
  //   return item ? item.count : 0;
  // };
  const getCountForMode = (value: string) => {
  // Normalisation des valeurs si nécessaire
  const normalizedValue: string =
    {
      'Home Office': 'Home Office',
      'Flex Office': 'Flex Office',
      'Business Travel': 'Business Travel', // pour cohérence
      'Third Party Site': 'Third Party Site',
      'Exeptional Home office': 'Exeptional Home office',
      
      Leave: 'Leave',
      Meeting: 'Meeting',
    }[value] || value;

  // Cherche dans workModeData exactement le nom de l'API
  const item = workModeData.find(
    (item) => item.workMode === normalizedValue
  );

  return item ? item.count : 0;
};

// Utilisation
const flexOfficeCount = getCountForMode("Flex Office");
const homeOfficeCount = getCountForMode("Home Office");
const exceptionalCount = getCountForMode("Exeptional Home office");
const thirdPartyCount = getCountForMode("Third Party Site");
const travelCount = getCountForMode("Business Travel");
const leaveCount = getCountForMode("Leave");

  return (
    //  <div className="reporting-dashboard">
    <Panel
      style={{ background: 'none' }}
      header={
        <Stack justifyContent="space-between">
          <h3 className="title">{t('Teams & members dashboard')}</h3>
          <Tabs
            appearance="pills"
            activeKey={selectedPeriod}
            onSelect={key => setSelectedPeriod(Number(key))}
            justified
            tabPosition="left"
          >
            <Tab eventKey={0} title={t('Today')} />
            <Tab eventKey={7} title={t('Last 7 days')} />
            <Tab eventKey={15} title={t('Last 15 days')} />
            <Tab eventKey={30} title={t('Last 30 days')} />
          </Tabs>
        </Stack>
      }
    >
      {selectedPeriod == 0 && (
        <>
          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Panel className="chart-panel" header={t('Operations Today')}>
                <Chart
                  options={{
                    chart: { type: 'donut' },
                    labels: operationsData.map(op => formatOperationLabel(op._id)),
                    colors: operationColors,
                    legend: {
                      position: 'bottom',
                      formatter: seriesName =>
                        `${seriesName}: ${
                          operationsData.find(op => formatOperationLabel(op._id) === seriesName)
                            ?.count || 0
                        }`
                    }
                  }}
                  series={operationsData.map(op => op.count)}
                  type="donut"
                  height={350}
                />
              </Panel>
            </Col>

            <Col xs={24} md={12}>
              <Panel className="chart-panel" header={t('Work Mode Distribution')}>
                {pieChartData.series.length > 0 ? (
                  <Chart
                    options={{
                      labels: pieChartData.labels,
                      colors: ['#ff861c', '#2ec7ff', '#4c8dff', '#e91e63'],
                      legend: { position: 'bottom' }
                    }}
                    series={pieChartData.series}
                    type="pie"
                    height={350}
                  />
                ) : (
                  <div style={{ height: 350 }}>
                    <p>{t('No data available')}</p>
                  </div>
                )}
              </Panel>
            </Col>
          </Row>

          <Row gutter={24} style={{ marginTop: 10 }}>
            <Col xs={24}>
              <Panel className="chart-panel" header={t('Users with Combined Status (AM & PM)')}>
                <Chart
                  options={combinedStatusData.options}
                  series={combinedStatusData.series}
                  type="bar"
                  height={350}
                />
              </Panel>
            </Col>
          </Row>
        </>
      )}
      {[7, 15, 30].includes(selectedPeriod) && (
        <Grid fluid>
          <Stack
            // justifyContent="center"
            justifyContent="space-around"
            alignItems="center"
            className="dashboard-header mt-20"
            wrap
            spacing={40}
          >
            {modes.map((mode, index) => {
              const count = getCountForMode(mode.value);
              return (
                <div key={index} className="card-balance" style={{ background: mode.background }}>
                  <div className="balance-header" style={{ color: '#fff' }}>
                    <h3>{count}</h3>
                    {mode.icon}
                  </div>
                  <Text muted style={{ marginTop: '10px', color: '#fff' }}>
                    {mode.label}
                  </Text>
                </div>
              );
            })}
          </Stack>

          <Row className="show-grid" gutter={16} style={{ marginBottom: 24, marginTop: '40px' }}>
            {/* Chart 1 - Reservation */}
            <Col xs={24} md={12} style={{ padding: 0 }}>
              <Panel className="chart-panel" header={t('Bookings per week')}>
                <div style={{ height: 300, width: '100%' }}>
                  {reservationData ? (
                    <Chart
                      options={{
                        chart: {
                          type: 'bar',
                          height: 300
                        },
                        plotOptions: {
                          bar: {
                            columnWidth: reservationData.series.length <= 2 ? '40%' : '50%'
                            // distributed: true a été supprimé
                          }
                        },
                        xaxis: {
                          categories: reservationData.categories
                        },
                        yaxis: {
                          tickAmount: 5,
                          min: 0,
                          max: 400,
                          labels: {
                            formatter: val => Math.floor(val)
                          }
                        },
                        tooltip: {
                          enabled: true,
                          y: { formatter: val => `${val} ` }
                        },
                        colors: ['#33b5ff'], // Une seule couleur maintenant
                        dataLabels: { enabled: false }
                      }}
                      series={reservationData.series}
                      type="bar"
                      height={300}
                    />
                  ) : (
                    <Loader center content="Chargement..." />
                  )}
                </div>
              </Panel>
            </Col>

            {/* Chart 2 - Reservation vs Check-ins */}
            <Col xs={24} md={12} style={{ padding: 0 }}>
              <Panel
                className="chart-panel"
                header={t('Bookings with check in vs Bookings without check in')}
              >
                <div style={{ height: 300, width: '100%' }}>
                  {reservationStats ? (
                    <Chart
                      options={{
                        chart: {
                          type: 'donut',
                          height: 300,
                          width: '100%'
                        },
                        labels: [t('Bookings without check in'), t('Bookings with check in')],
                        colors: ['#ff861c', '#fe3993'],
                        legend: {
                          position: 'bottom',
                          horizontalAlign: 'center'
                        },
                        plotOptions: {
                          pie: {
                            donut: {
                              size: '65%',
                              labels: {
                                show: true,
                                total: {
                                  show: true,
                                  label: t('Total of bookings'),
                                  formatter: () =>
                                    (
                                      reservationStats.reservationCount +
                                      reservationStats.checkinCount
                                    ).toString()
                                }
                              }
                            }
                          }
                        },
                        dataLabels: {
                          enabled: false
                        },
                        responsive: [
                          {
                            breakpoint: 480,
                            options: {
                              chart: {
                                width: 200
                              },
                              legend: {
                                position: 'bottom'
                              }
                            }
                          }
                        ]
                      }}
                      series={[reservationStats.reservationCount, reservationStats.checkinCount]}
                      type="donut"
                      height={300}
                    />
                  ) : (
                    <Loader center content="Loading..." />
                  )}
                </div>
              </Panel>
            </Col>
          </Row>

          {/* Charts Row 2 */}
          <Row className="show-grid" gutter={16}>
            <Col xs={24}>
              <Panel className="chart-panel" header={t('Operations per Teams')}>
                <Chart
                  options={{ ...departmentChartData.options }}
                  series={departmentChartData.series}
                  type="bar"
                  height={350}
                />
              </Panel>
            </Col>
          </Row>

          {/* Operations List */}
          <Row className="show-grid mt-30" gutter={16} style={{ marginTop: 30 }}>
            <Col xs={24}>
              <Panel
                className="chart-panel"
                header={
                  <Stack justifyContent="space-between">
                    {t('Operations List')}
                    <Button appearance="primary" onClick={exportToExcel} title="Export">
                      <BiExport />
                    </Button>
                  </Stack>
                }
              >
                {loading ? (
                  <Loader center content="Loading..." />
                ) : operations.length > 0 ? (
                  <>
                    <Table
                      height={parseInt(height)}
                      minHeight={parseInt(minHeight)}
                      maxHeight={parseInt(maxHeight)}
                      autoHeight={autoHeight}
                      data={operations.slice((page - 1) * rowsPerPage, page * rowsPerPage)}
                      bordered
                      cellBordered
                    >
                      <Column flexGrow={1} align="center" fixed>
                        <HeaderCell>{t('Last Name')}</HeaderCell>
                        <Cell>{rowData => rowData.user?.lastname || 'N/A'}</Cell>
                      </Column>
                      <Column flexGrow={1} align="center" fixed>
                        <HeaderCell>{t('First Name')}</HeaderCell>
                        <Cell>{rowData => rowData.user?.firstname || 'N/A'}</Cell>
                      </Column>
                      <Column flexGrow={1} align="center">
                        <HeaderCell>{t('Service Line')}</HeaderCell>
                        <Cell>{rowData => rowData.user?.serviceLine?.serviceLine || 'N/A'}</Cell>
                      </Column>
                      <Column flexGrow={1} align="center">
                        <HeaderCell>{t('Operation Type')}</HeaderCell>
                        <Cell dataKey="OperationType" />
                      </Column>
                      <Column flexGrow={1} align="center">
                        <HeaderCell>{t('Reservation Day')}</HeaderCell>
                        <Cell>{rowData => normalizeDateField(rowData)}</Cell>
                      </Column>
                    </Table>
                    <Pagination
                      prev
                      next
                      first
                      last
                      total={operations.length}
                      limit={rowsPerPage}
                      activePage={page}
                      onChangePage={setPage}
                      style={{ marginTop: 10 }}
                    />
                  </>
                ) : (
                  <p>{t('No data found.')}</p>
                )}
              </Panel>
            </Col>
          </Row>
        </Grid>
      )}
    </Panel>
    // </div>
  );
};

export default ReportingDashboard;
